<div #originRef
     (click)="showPopover(originRef)"
     [class.bg-hover]="dropdownOpen"
     class="relative flex items-center py-1 pl-3 pr-1 rounded cursor-pointer select-none trans-ease-out hover:bg-hover"
     matRipple>
  <div class="hidden font-medium leading-snug body-1 ltr:mr-3 rtl:ml-3 sm:block">David Smith</div>
  <div class="flex items-center justify-center rounded-full h-9 w-9 text-primary bg-primary/10">
    <mat-icon svgIcon="mat:person"></mat-icon>
  </div>
</div>
